export const PERMISSIONS = {
  // Route
  WORKLIST_ROUTE: "WORKLIST_ROUTE",
  PATIENT_ROUTE: "PATIENT_ROUTE",
  REPORT_ROUTE: "REPORT_ROUTE",
  TRANSFER_WOUND_ASSESSMENT_ROUTE: "TRANSFER_WOUND_ASSESSMENT_ROUTE",
  MERGE_WOUND_ASSESSMENT_ROUTE: "MERGE_WOUND_ASSESSMENT_ROUTE",
  ADMIN_ROUTE: "ADMIN_ROUTE",

  PATIENT: "PATIENT",
  ADD_PATIENT: "ADD_PATIENT",
  ASSESSMENT_THREE_DOT_MENU: "ASSESSMENT_THREE_DOT_MENU",
  ASSESSMENT: "ASSESSMENT",
  CHARACTERISTIC: "CHARACTERISTIC",
  MEASUREMENT: "MEASUREMENT",
  MEASUREMENT_BUTTON: "MEASUREMENT_BUTTON",
  TREATMENT: "TREATMENT",
  TREATMENT_SEARCH: "TREATMENT_SEARCH",
  TREATMENT_ADD_INTERVENTION: "TREATMENT_ADD_INTERVENTION",
  NOTES: "NOTES",
  CUSTOM_LABEL: "CUSTOM_LABEL",
  SIGN: "SIGN",
  LOCK: "LOCK",
  EXT_SIGN_LOCK: "EXT_SIGN_LOCK",
  RE_EVAL: "RE_EVAL",

  ADMIN: "ADMIN",

  USER_PROFILE: "USER_PROFILE",
  USER_PROFILE_UPDATE_PASSWORD: "USER_PROFILE_UPDATE_PASSWORD",

  //buttons
  WOUND_ASSESSMENT_WITHOUT_PHOTO: "WOUND_ASSESSMENT_WITHOUT_PHOTO",
  RISK_ASSESSMENT: "RISK_ASSESSMENT",
  UNABLE_TO_ACCESS_WOUND: "UNABLE_TO_ACCESS_WOUND",
  REGISTER_PATIENT_FOR_MOBILE: "REGISTER_PATIENT_FOR_MOBILE",
  ASSESSMENT_NOTE_DELETE: "ASSESSMENT_NOTE_DELETE",
  ASSESSMENT_NOTE_EDIT: "ASSESSMENT_NOTE_EDIT",

  //Edit
  NOTIFICATION_EDIT: "NOTIFICATION_EDIT",
  ADT_EDIT: "ADT_EDIT",
  ANATOMY_EDIT: "ANATOMY_EDIT",
  CHARACTERISTIC_HISTORY_EDIT: "CHARACTERISTIC_HISTORY_EDIT",
  CHARACTERISTIC_TISSUE_EDIT: "CHARACTERISTIC_TISSUE_EDIT",
  CHARACTERISTIC_TOUCH_EDIT: "CHARACTERISTIC_TOUCH_EDIT",
  CHARACTERISTIC_CUSTOM_FORM_EDIT: "CHARACTERISTIC_CUSTOM_FORM_EDIT",
  CHARACTERISTIC_CLASSIFICATION_EDIT: "CHARACTERISTIC_CLASSIFICATION_EDIT",
  CHARACTERISTIC_PROGRESS_EDIT: "CHARACTERISTIC_PROGRESS_EDIT",
  MEASUREMENT_EDIT: "MEASUREMENT_EDIT",
  TREATMENT_EDIT: "TREATMENT_EDIT",

  // Customer admin
  CUSTOMER_SALES_AREA_EDIT: "CUSTOMER_SALES_AREA_EDIT",
};
